export const INTAKE_IMAGE_ACCEPT = 'image/jpeg,image/png';
export const INTAKE_AUDIO_ACCEPT =
    'audio/*,audio/webm,audio/mp4,audio/mpeg,audio/wav,audio/ogg,audio/aac,audio/x-m4a,.webm,.m4a,.mp3,.wav,.ogg,.aac,.mp4';
export const INTAKE_FILE_ACCEPT = `${INTAKE_IMAGE_ACCEPT},${INTAKE_AUDIO_ACCEPT}`;

const IMAGE_TYPES = new Set(['image/jpeg', 'image/jpg', 'image/png']);
const IMAGE_EXTS = new Set(['jpg', 'jpeg', 'png']);
const AUDIO_EXTS = new Set(['webm', 'm4a', 'mp3', 'wav', 'ogg', 'aac', 'mp4']);

function fileExt(name: string): string {
    const dot = name.lastIndexOf('.');
    return dot >= 0 ? name.slice(dot + 1).toLowerCase() : '';
}

function fileMime(file: File): string {
    return (file.type || '').split(';')[0].trim().toLowerCase();
}

export function intakeFileKind(file: File): 'audio' | 'image' | null {
    const mime = fileMime(file);
    if (IMAGE_TYPES.has(mime)) return 'image';
    if (mime.startsWith('audio/') || mime === 'video/webm' || mime === 'video/mp4') {
        return 'audio';
    }
    const ext = fileExt(file.name);
    if (IMAGE_EXTS.has(ext)) return 'image';
    if (AUDIO_EXTS.has(ext)) return 'audio';
    return null;
}

export function partitionIntakeFiles(files: File[]): {
    accepted: File[];
    rejected: File[];
} {
    const accepted: File[] = [];
    const rejected: File[] = [];
    for (const file of files) {
        if (intakeFileKind(file)) accepted.push(file);
        else rejected.push(file);
    }
    return { accepted, rejected };
}

export function buildLeadParseForm(params: {
    text?: string;
    files?: File[];
}): FormData {
    const form = new FormData();
    const text = params.text?.trim();
    if (text) form.append('text', text);
    for (const file of params.files || []) {
        const kind = intakeFileKind(file);
        if (kind === 'audio') form.append('audio', file);
        else if (kind === 'image') form.append('images', file);
    }
    return form;
}
